import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from '../../../environments/environment';
import {createRequestOption} from '../../shared/util';
import {IMember} from '../../shared/model';

type EntityResponseInfo = HttpResponse<IMember>;
type EntityArrayResponseInfo = HttpResponse<IMember[]>;

@Injectable({ providedIn: 'root' })
export class MemberService {
  public resourceUrl = environment.SERVER_API_URL + 'api/admin/useManagement';

  constructor(protected http: HttpClient) {}

  find(id: number): Observable<EntityResponseInfo> {
    return this.http.get<IMember>(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  query(req?: any): Observable<EntityArrayResponseInfo> {
    const options = createRequestOption(req);
    return this.http.get<IMember[]>(this.resourceUrl, { params: options, observe: 'response' });
  }
}
